<template>
    <div class="d-flex align-items-md-center justify-content-center font-size-14 py-1 px-2" :class="[backgroundColor]">
        <div class="icon font-size-20 pe-1 icon-vertical-center" :class="[icon]" />
        <div>
            <!-- 2 mois offerts sur votre abonnement internet. -->
            <strong id="headerBanner" v-html="label" />
        </div>
    </div>
</template>

<script>
export default {
    name: "ShowcaseHeaderBanner",
    components: {},
    props: {
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        backgroundColor: {
            type: String,
            required: true
        }
    },
    data() {
        return {
        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
</style>
